import React, { createContext, useContext, useState, useEffect } from "react";

interface VersionContextProps {
    version: string;
}

const VersionContext = createContext<VersionContextProps | undefined>(undefined);

export const VersionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [version, setVersion] = useState<string>("Betöltés...");

    useEffect(() => {
        fetch(`/version.json?timestamp=${new Date().getTime()}`)
            .then((res) => res.json())
            .then((data) => setVersion(data.version))
            .catch(() => setVersion("Unknown version"));
    }, []);


    console.log("🚀 App version:", version);

    return (
        <VersionContext.Provider value={{ version }}>
            {children}
        </VersionContext.Provider>
    );
};

export const useVersion = () => {
    const context = useContext(VersionContext);
    if (!context) {
        throw new Error("useVersion must be used within a VersionProvider");
    }
    return context;
};
